import { bindable, autoinject, bindingMode } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { CustomerInfoStore, CustomerRegistrationInfo } from '../../services/customer-info-store';
import { OrganizationInfo, SatelliteViewProperties } from '../../services/organization-info';
import { HttpClient, json } from 'aurelia-fetch-client';

@autoinject
export class LicensingOverviewSatellite {

    organizationId: string = null;
    contractId: string = null;
    customer: CustomerRegistrationInfo = null;
    chartonly: boolean = false;
    hidechartbtn: boolean = false;

    constructor(private dialogService: DialogService, private customerInfoStore: CustomerInfoStore, private orgInfo: OrganizationInfo, private http: HttpClient) {
        http.configure(x => {
            x.useStandardConfiguration()
        });
    }

    activate(routeParams: SatelliteViewProperties) {
        console.log('activate licensing-overview-satellite', routeParams);

        this.organizationId = routeParams.organizationId;
        this.contractId = routeParams.contractId;
        this.chartonly = routeParams.chartOnly.toString() === "true";
        this.hidechartbtn = routeParams.hideChartBtn.toString() === "true";
        this.customer = this.customerInfoStore.getCustomerInfo(routeParams.organizationId, routeParams.contractId);
    }

}



// WEBPACK FOOTER //
// ./ClientApp/app/components/licensing-overview/licensing-overview-satellite.ts